import { Form } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import type React from 'react';
import type BaseProfilEcritureMouvement from '../../../classes/mouvements/profilEcriture/Base/BaseProfilEcritureMouvement';

interface ModeReglementSelectProps {
	placeholder?: string;
	profilEcriture: BaseProfilEcritureMouvement;
	sens: string;
	value: string;
	onChange: (
		e: React.ChangeEvent<HTMLInputElement>,
		{
			name,
			value,
		}: {
			name: string;
			value: string;
		},
	) => void;
	[key: string]: any;
}

const ModeReglementSelect = ({
	placeholder = '',
	onChange,
	profilEcriture,
	sens,
	value,
	...rest
}: ModeReglementSelectProps) => (
	<Form.Field
		control={Combobox}
		data-testid="modeReglement"
		label="Mode de règlement"
		name="modeReglement"
		onChange={onChange}
		options={profilEcriture?.getModeReglement(sens)}
		placeholder={placeholder}
		required
		selection
		value={value}
		{...rest}
	/>
);

export default ModeReglementSelect;
